import type { IGNavigateMenu } from '~/presentation/common';

import { INavigateKey } from '~/types/navigate';

export const ROUTE_PATH: Record<INavigateKey, string> = {
  [INavigateKey.Home]: '/app',
  [INavigateKey.Analytics]: '/app/analytics',
  [INavigateKey.AnalyticsDetail]: '/app/analytics/detail',
  [INavigateKey.Plan]: '/app/plans',
  [INavigateKey.Preferences]: '/app/preferences',
  [INavigateKey.OnboardingSurvey]: '/app/onboarding',
  [INavigateKey.OnboardingTemplate]: '/app/onboarding/template',
  [INavigateKey.OnboardingPricing]: '/app/onboarding/price',
  [INavigateKey.OnboardingMultiPage]: '/app/onboarding/multipage',
  [INavigateKey.Campaigns]: '/app/campaign',
  [INavigateKey.CampaignNew]: '/app/campaign/new',
  [INavigateKey.CampaignTemplate]: '/app/campaign',
  [INavigateKey.CampaignMultipage]: '/app/campaign/multipage',
  [INavigateKey.CampaignPrice]: '/app/campaign/price',
  [INavigateKey.CampaignUrlRedirect]: '/app/campaign/url-redirect',
  [INavigateKey.ThankYou]: '/app/thank-you',
  [INavigateKey.Reports]: '/app/analytics/reports',
  [INavigateKey.OrderListing]: '/app/analytics/order-listing',
  [INavigateKey.Heatmap]: '/iframe/heatmap',
  [INavigateKey.DevMode]: '/app/dev-mode',
  [INavigateKey.CampaignDetails]: '/app/campaign/:id/detail',
  [INavigateKey.CampaignAnalytic]: '/app/campaign/:id/analytics',
  [INavigateKey.CampaignGroupDetails]: '/app/campaign/multipage/:id/detail',
  [INavigateKey.CampaignGroupAnalytic]: '/app/campaign/multipage/:id/analytics',
};

// Menu labels for shops on PageDashboardV2; keys not listed keep their NAVIGATE_MENU label.
export const NAVIGATE_MENU_LABEL_V2: Partial<Record<INavigateKey, string>> = {
  [INavigateKey.Campaigns]: 'A/B tests',
  [INavigateKey.Analytics]: 'Page Analytics',
};

export const NAVIGATE_MENU: IGNavigateMenu[] = [
  {
    key: INavigateKey.Home,
    label: 'Home',
    path: ROUTE_PATH[INavigateKey.Home],
    rel: 'home',
  },
  {
    key: INavigateKey.Campaigns,
    label: 'Experiments',
    path: ROUTE_PATH[INavigateKey.Campaigns],
    isNavigate: true,
  },
  {
    key: INavigateKey.Analytics,
    label: 'Analytics',
    path: ROUTE_PATH[INavigateKey.Analytics],
    isNavigate: true,
  },
  {
    key: INavigateKey.Plan,
    label: 'Plans',
    path: ROUTE_PATH[INavigateKey.Plan],
    isNavigate: true,
  },
  {
    key: INavigateKey.Preferences,
    label: 'Preferences',
    path: ROUTE_PATH[INavigateKey.Preferences],
    isNavigate: true,
  },
  {
    key: INavigateKey.Heatmap,
    label: 'Heatmap',
    path: ROUTE_PATH[INavigateKey.Heatmap],
    isNavigate: true,
  },
  {
    key: INavigateKey.DevMode,
    label: 'Dev mode',
    path: ROUTE_PATH[INavigateKey.DevMode],
    isNavigate: true,
  },
];
